module.exports = __webpack_public_path__ + "static/media/LB.5e6ca722.svg";